import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const bodyfatfitnessApiService = createApi({
  reducerPath: "bodyfatfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createBodyfat: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `bodyfatfitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getBodyfat: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `bodyfatfitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateBodyfat: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `bodyfatfitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateBodyfatMutation,
  useGetBodyfatQuery,
  useUpdateBodyfatMutation,
} = bodyfatfitnessApiService;
